import { memo, useMemo } from 'react';
import { getPerfusionTime } from '../../../ClinicalData/utils';
import { useHHMMCounter, delimiter } from '../../../CaseCard/Blocks/Timeline/util';
import { TXCenterBadge } from '../TXCenterBadge/TXCenterBadge';

type OCSTimeDisplayProps = {
  organOnOCSTimestamp: string | null;
  caseName: string;
  txCenterCode?: string;
};

const OCSTimeDisplayComponent = ({ organOnOCSTimestamp, caseName, txCenterCode }: OCSTimeDisplayProps) => {
  const initialTime = useMemo(
    () => (organOnOCSTimestamp ? getPerfusionTime(new Date(), organOnOCSTimestamp) : undefined),
    [organOnOCSTimestamp],
  );

  const [hours, minutes] = useHHMMCounter(!!organOnOCSTimestamp, initialTime);
  const displayTime = hours && minutes ? `${hours}${delimiter}${minutes}` : '00:00';

  return (
    <div className="flex items-center flex-1">
      <div className="flex items-center gap-1">
        {txCenterCode ? <TXCenterBadge txCenterCode={txCenterCode} /> : null}
      </div>
      <div className="flex flex-col">
        <span className="text-base-10 text-s-m mb-1">{caseName}</span>
        <div className="flex items-center gap-2">
          <span className="text-maroon-20 text-xl-sb">OCS {displayTime}</span>
        </div>
      </div>
    </div>
  );
};

export const OCSTimeDisplay = memo(OCSTimeDisplayComponent);
